<template>
  <div
    class="product-counter"
    :class="{visible: shoppingState}"
    v-if="$route.name === 'list'">
    {{ numberOfCollectedItems }} / {{ items.length }} producten verzameld
  </div>
</template>

<script>
    export default {
      name: 'product-counter',
      computed: {
        shoppingState () {
          return this.$store.state.commonStore.shopping
        },
        items () {
          return this.$store.getters['getCurrentList'].items || []
        },
        numberOfCollectedItems () {
          let numberOfCollectedItems = 0
          this.items.forEach(item => { if (item.collected) numberOfCollectedItems += 1 })
          return numberOfCollectedItems
        }
      }
    }
</script>

<style lang="scss" scoped>
  .product-counter {
    width: 100%;
    height: 56px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 56px;
    left: 0;
    z-index: 98;
    transform: translateY(-100%);
    opacity: 0;
    transition: all 0.15s ease-in-out;
    box-shadow:
      0 2px 4px -1px rgba(0,0,0,.2),
      0 4px 5px 0 rgba(0,0,0,.14),
      0 1px 10px 0 rgba(0,0,0,.12);

    &.visible {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// ProductCounter.vue?5e1e08ee